import { render, staticRenderFns } from "./ConflictInstructionTableField.vue?vue&type=template&id=c4063736&scoped=true"
import script from "./ConflictInstructionTableField.vue?vue&type=script&lang=js"
export * from "./ConflictInstructionTableField.vue?vue&type=script&lang=js"
import style0 from "./ConflictInstructionTableField.vue?vue&type=style&index=0&id=c4063736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4063736",
  null
  
)

export default component.exports